import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { PanelConfig } from './_config/panel.model';

@Component({
  selector: 'plyca-ui-panel',
  templateUrl: './panel.component.html',
  styleUrl: './panel.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlycaUiPanelComponent {
  public config: InputSignal<PanelConfig> = input.required<PanelConfig>();
}
